import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-caret-down",
  "use": "oc-caret-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-caret-down\"><path d=\"M798.165333 414.165333a42.666667 42.666667 0 0 0-57.621333-62.826666l-2.709333 2.496L512 579.626667 286.165333 353.834667a42.666667 42.666667 0 0 0-57.621333-2.496l-2.709333 2.496a42.666667 42.666667 0 0 0-2.496 57.621333l2.496 2.709333 256 256a42.666667 42.666667 0 0 0 57.621333 2.496l2.709333-2.496 256-256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol